import { load3DLogo } from '../vendor/index';

export class Logo3dText {
	constructor() {
		this.container = document.querySelector('.logo3dText');
		this.logo = document.querySelector('#logo3dText-logo');
	}

	init() {
		load3DLogo({ container: this.logo });
	}
}
